<h1 class="text-xl lg:flex lg:flex-row lg:text-2xl font-app-bold mb-5 md:mb-10 mt-5 lg:ml-[40px] bg-red-300">
  {{ titleKey | translate }}{{ reference }}
</h1>

